import { Add, Close } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import { useState } from 'react';
import { removeFacilityPersonnel } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function PersonnelDelete({ open, onClose, facilityId, personelInfo }) {
  const [saving, setSaving] = useState(false);

  const handleRemovePersonel = async (values) => {
    setSaving(true);
    try {
      const payload = {
        email: [personelInfo?.email],
      };
      console.log('payload', payload);

      console.log('facilityId', facilityId);

      const res = await removeFacilityPersonnel(facilityId, payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        onClose();
      } else {
        openNotification({ type: 'error', message: status?.desc });
      }
    } catch (error) {
      openNotification({ type: 'error', message: 'Something went wrong. Please try again' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Remove Personnel
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{}}>
        <Typography>
          You are about to remove <strong>{personelInfo?.fullName}</strong> from the Facility.
        </Typography>
        <br />
        <Typography color="error">Are you sure you want to do this?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="info"
          disabled={saving}
          startIcon={saving && <CircularProgress size={20} />}
          sx={{ textTransform: 'none', borderRadius: 20 }}
          onClick={handleRemovePersonel}
        >
          Yes, Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
